import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { CampaignApi, type IResponseFullCampaign } from 'entities/Campaign'

export const openDisableCampaignModal = (
  campaignId: number,
  onSuccess: (data: IResponseFullCampaign) => void
) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    type: ModalTypeList.ALERT,
    title: 'Disable Campaign?',
    desc: 'This will end all active conversations between the Campaign and enrolled contacts',
    primaryAction: {
      text: 'Disable',
      onAction: async () => {
        try {
          const { data } = await CampaignApi.patch(campaignId, { status: 'disabled' })
          onSuccess(data.data)
          modalStore.closeModal(id)
        } catch (e) {
          logger.error(e)
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => modalStore.closeModal(id),
    },
  })
}
